<!--
  No dialog: a <dialog> shown as a popover takes focus on every hover. Screen readers get the card through the
  trigger instead, which the directive describes by its heading and description.
-->
<div
  #content
  [class]="'popover-content popover-' + placement()"
  popover="manual"
  (pointerenter)="onHover($event, true)"
  (pointerleave)="onHover($event, false)"
>
  <div class="popover-animation card">
    <img class="visual" [src]="image()" alt="" />
    <div class="body">
      <div class="heading" [id]="headingId">
        <app-pill class="tag">{{ 'FEATURE_ONBOARDING_NEW' | translate }}</app-pill>
        <h2 class="title typography-large-medium">{{ titleKey() | translate }}</h2>
      </div>
      <p class="description typography-body-regular" [id]="descriptionId">{{ descriptionKey() | translate }}</p>
      <div class="actions">
        <button app-button class="discover" type="button" (click)="discover.emit()">
          {{ 'FEATURE_ONBOARDING_DISCOVER' | translate }}
        </button>
        <button app-button class="acknowledge" type="button" variant="outline-inverse" (click)="acknowledge.emit()">
          {{ 'FEATURE_ONBOARDING_OK' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
